import { render } from "./TippingV3.vue?vue&type=template&id=18ba779a"
import script from "./TippingV3.vue?vue&type=script&lang=js"
export * from "./TippingV3.vue?vue&type=script&lang=js"

import "./TippingV3.vue?vue&type=style&index=0&id=18ba779a&lang=css"

import exportComponent from "C:\\Users\\Adrian\\OneDrive\\Documents\\Appsanely Ltd\\thankU\\_thankuapp\\thanku\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__